export default __webpack_public_path__ + "static/media/pattern_44.4de1d25d.svg";